import api from "../api/axios";

// axios baseURL = /api/v1
// donc toutes les routes admin commencent par /admin
const ADMIN_PREFIX = "/admin";

export const AdminCreditsAPI = {
  // ======================
  // Tags
  // ======================
  listTags: () => api.get(`${ADMIN_PREFIX}/tags`),
  createTag: (payload) => api.post(`${ADMIN_PREFIX}/tags`, payload),
  deleteTag: (id) => api.delete(`${ADMIN_PREFIX}/tags/${id}`),
  updateTag: (id, payload) => api.put(`${ADMIN_PREFIX}/tags/${id}`, payload),


  // ======================
  // Labs
  // ======================
  listLabs: () => api.get(`${ADMIN_PREFIX}/labs`),
  getLabTags: (labId) => api.get(`${ADMIN_PREFIX}/labs/${labId}/tags`),
  setLabTags: (labId, tags) => api.put(`${ADMIN_PREFIX}/labs/${labId}/tags`, tags),

  // ======================
  // Users credits
  // ======================
  searchUsers: (query) =>
    api.get(`${ADMIN_PREFIX}/users/search`, {
      params: { query },
    }),

  getUserWallets: (userId) =>
    api.get(`${ADMIN_PREFIX}/users/${userId}/wallets`),

  getUserTransactions: (userId) =>
    api.get(`${ADMIN_PREFIX}/users/${userId}/transactions`),

  adminCredit: (userId, payload) =>
    api.post(`${ADMIN_PREFIX}/users/${userId}/credit`, payload),

  adminDebit: (userId, payload) =>
    api.post(`${ADMIN_PREFIX}/users/${userId}/debit`, payload),

  voidTx: (txId, payload) =>
    api.post(`${ADMIN_PREFIX}/transactions/${txId}/void`, payload),

  // ======================
  // Settings
  // ======================
  getSettings: () => api.get(`${ADMIN_PREFIX}/settings`),

  // ======================
  // Packages
  // ======================
  listPackages: () => api.get(`${ADMIN_PREFIX}/packages`),
  createPackage: (payload) =>
    api.post(`${ADMIN_PREFIX}/packages`, payload),

  updatePackage: (id, payload) =>
    api.put(`${ADMIN_PREFIX}/packages/${id}`, payload),

  togglePackage: (id) =>
    api.patch(`${ADMIN_PREFIX}/packages/${id}/toggle-active`),

  getPackageTags: (id) =>
    api.get(`${ADMIN_PREFIX}/packages/${id}/tags`),

  setPackageTags: (id, tags) =>
    api.put(`${ADMIN_PREFIX}/packages/${id}/tags`, tags),
};
